const tablet = 768;
// Raise the mobile's max-width to be compatible with more mobile devices
const mobile = 415;

export const isSmallDevice = () => window.matchMedia(`(max-width: ${tablet}px)`).matches;
export const isMobileDevice = () => window.matchMedia(`(max-width: ${mobile}px)`).matches;
export const isBreakpoint = () => window.matchMedia('(max-width: 596px)').matches;
